import styles from "./Logo.module.css";

type Variant = "dark" | "light";

// The wordmark's width in em: the mark (1.5em), the gap (0.4em) and "Feedback Journey" in Unna.
// The font size is derived from it, so `w` keeps giving roughly the same width as before.
const WIDTH_IN_EM = 9.5;

// The mark on a 34×34 grid: a ring, the coral journey line and the amber star.
const Mark = ({ variant }: { variant: Variant }) => (
  <svg className={styles.mark} viewBox='0 0 34 34' aria-hidden='true' focusable='false'>
    <circle className={styles[`ring_${variant}`]} cx='17' cy='17' r='15' fill='none' strokeWidth='1.5' opacity='0.6' />
    <path className={styles.line} d='M9 22 C 14 22.5, 17 22, 19.5 17 S 23.5 8, 28.5 7.4' fill='none' strokeWidth='2.4' strokeLinecap='round' />
    <path
      className={styles.star}
      d='M28.5 2 C 28.5 6.5, 29.4 7.4, 33.9 7.4 C 29.4 7.4, 28.5 8.3, 28.5 12.8 C 28.5 8.3, 27.6 7.4, 23.1 7.4 C 27.6 7.4, 28.5 6.5, 28.5 2 Z'
    />
  </svg>
);

// The text is HTML, not SVG <text>: html2canvas drops the webfont inside an SVG when the Journey Card is captured.
const Wordmark = ({ variant, w }: { variant: Variant; w: number }) => (
  <span className={`${styles.wordmark} ${styles[variant]}`} style={{ fontSize: w / WIDTH_IN_EM }}>
    <Mark variant={variant} />
    <span>
      <b>Feedback</b> Journey
    </span>
  </span>
);

// For dark (petrol) backgrounds.
export const FeedbackJourneyLogo = ({ w = 233 }: { w?: number }) => <Wordmark variant='dark' w={w} />;

// For light (cream and white) backgrounds.
export const FeedbackJourneyLogoDark = ({ w = 233 }: { w?: number }) => <Wordmark variant='light' w={w} />;
